import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { EyeOff } from 'lucide-react';

export interface ProjectMenuTarget { id: number; title: string; x: number; y: number; origin: HTMLElement }

export function ProjectContextMenu({ target, onClose, onHide }: { target: ProjectMenuTarget; onClose: () => void; onHide: () => void }) {
  const surface = useRef<HTMLDivElement>(null);
  const action = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    action.current?.focus();
    const outside = (event: PointerEvent) => { if (event.target instanceof Node && !surface.current?.contains(event.target)) onClose(); };
    const keyboard = (event: KeyboardEvent) => {
      if (event.key === 'Escape') { event.preventDefault(); event.stopImmediatePropagation(); onClose(); target.origin.focus(); }
      else if (event.key === 'Tab') onClose();
    };
    document.addEventListener('pointerdown', outside);
    document.addEventListener('keydown', keyboard, true);
    window.addEventListener('resize', onClose);
    window.addEventListener('blur', onClose);
    window.addEventListener('scroll', onClose, true);
    return () => {
      document.removeEventListener('pointerdown', outside);
      document.removeEventListener('keydown', keyboard, true);
      window.removeEventListener('resize', onClose);
      window.removeEventListener('blur', onClose);
      window.removeEventListener('scroll', onClose, true);
    };
  }, [target, onClose]);
  return createPortal(<div ref={surface} className="regulation-window-menu project-context-menu" role="menu" aria-label={`Действия с проектом ${target.title}`} style={{ left: Math.max(8, Math.min(target.x, window.innerWidth - 256)), top: Math.max(8, Math.min(target.y, window.innerHeight - 60)) }}>
    <button ref={action} type="button" role="menuitem" onClick={onHide}><EyeOff size={17}/><span>Скрыть проект</span></button>
  </div>, document.body);
}
